// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShareTargetRouteImport } from './routes/share-target'
import { Route as NotPermittedRouteImport } from './routes/not-permitted'
import { Route as CreateRouteImport } from './routes/create'
import { Route as ToolsRouteImport } from './routes/_tools'
import { Route as StaticRouteImport } from './routes/_static'
import { Route as ManageRouteImport } from './routes/_manage'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UploadIndexRouteImport } from './routes/upload/index'
import { Route as ResultsIndexRouteImport } from './routes/results/index'
import { Route as SShareIdRouteImport } from './routes/s/$shareId'
import { Route as ProjectShareIdRouteImport } from './routes/project/$shareId'
import { Route as FileShareIdRouteImport } from './routes/file/$shareId'
import { Route as DrawingShareIdRouteImport } from './routes/drawing/$shareId'
import { Route as ApiQrcodeRouteImport } from './routes/api/qrcode'
import { Route as StaticTermsRouteImport } from './routes/_static/terms'
import { Route as StaticPrivacyRouteImport } from './routes/_static/privacy'
import { Route as StaticPricingRouteImport } from './routes/_static/pricing'
import { Route as StaticLegalRouteImport } from './routes/_static/legal'
import { Route as StaticInboundEmailLimitsRouteImport } from './routes/_static/inbound-email-limits'
import { Route as StaticFaqRouteImport } from './routes/_static/faq'
import { Route as StaticDocsRouteImport } from './routes/_static/docs'
import { Route as StaticContactRouteImport } from './routes/_static/contact'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLogoutRouteImport } from './routes/_auth/logout'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as ToolsToolsIndexRouteImport } from './routes/_tools/tools/index'
import { Route as StaticDocsIndexRouteImport } from './routes/_static/docs/index'
import { Route as StaticDocsWorkflowsRouteImport } from './routes/_static/docs/workflows'
import { Route as StaticDocsTemplatesRouteImport } from './routes/_static/docs/templates'
import { Route as StaticDocsStorageRouteImport } from './routes/_static/docs/storage'
import { Route as StaticDocsQuickstartRouteImport } from './routes/_static/docs/quickstart'
import { Route as StaticDocsEmailInboundRouteImport } from './routes/_static/docs/email-inbound'
import { Route as StaticDocsApiRouteImport } from './routes/_static/docs/api'
import { Route as ManageManageIndexRouteImport } from './routes/_manage/manage/index'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login.index'
import { Route as AuthLoginEmailRouteImport } from './routes/_auth/login.email'
import { Route as ToolsToolsMaterialsIndexRouteImport } from './routes/_tools/tools/materials/index'
import { Route as ManageManageWorkflowsIndexRouteImport } from './routes/_manage/manage/workflows/index'
import { Route as ManageManageUsageIndexRouteImport } from './routes/_manage/manage/usage/index'
import { Route as ManageManageTemplatesIndexRouteImport } from './routes/_manage/manage/templates/index'
import { Route as ManageManageProjectsIndexRouteImport } from './routes/_manage/manage/projects/index'
import { Route as ManageManageOrganizeIndexRouteImport } from './routes/_manage/manage/organize/index'
import { Route as ManageManageOrganizationIndexRouteImport } from './routes/_manage/manage/organization/index'
import { Route as ManageManageOperationsIndexRouteImport } from './routes/_manage/manage/operations/index'
import { Route as ManageManageMergeIndexRouteImport } from './routes/_manage/manage/merge/index'
import { Route as ManageManageFilesIndexRouteImport } from './routes/_manage/manage/files/index'
import { Route as ManageManageDrawingsIndexRouteImport } from './routes/_manage/manage/drawings/index'
import { Route as ManageManageDashboardIndexRouteImport } from './routes/_manage/manage/dashboard/index'
import { Route as ManageManageAdminIndexRouteImport } from './routes/_manage/manage/admin/index'
import { Route as ManageManageAccountIndexRouteImport } from './routes/_manage/manage/account/index'
import { Route as ManageManageWorkflowsIdRouteImport } from './routes/_manage/manage/workflows/$id'
import { Route as ManageManageTemplatesIdRouteImport } from './routes/_manage/manage/templates/$id'
import { Route as ManageManageProjectsNewRouteImport } from './routes/_manage/manage/projects/new'
import { Route as ManageManageProjectsIdRouteImport } from './routes/_manage/manage/projects/$id'
import { Route as ManageManageOrganizationSettingsRouteImport } from './routes/_manage/manage/organization/settings'
import { Route as ManageManageOrganizationOperationTypesRouteImport } from './routes/_manage/manage/organization/operation-types'
import { Route as ManageManageFilesShareIdRouteImport } from './routes/_manage/manage/files/$shareId'
import { Route as ManageManageDrawingsSearchRouteImport } from './routes/_manage/manage/drawings/search'
import { Route as ManageManageDrawingsRapidRouteImport } from './routes/_manage/manage/drawings/rapid'
import { Route as ManageManageDrawingsNewRouteImport } from './routes/_manage/manage/drawings/new'
import { Route as ManageManageDrawingsIdRouteImport } from './routes/_manage/manage/drawings/$id'
import { Route as ManageManageAdminTemplatesRouteImport } from './routes/_manage/manage/admin/templates'
import { Route as ManageManageAdminSettingsRouteImport } from './routes/_manage/manage/admin/settings'
import { Route as ManageManageAdminRateLimitsRouteImport } from './routes/_manage/manage/admin/rate-limits'
import { Route as ManageManageAdminOperationsRouteImport } from './routes/_manage/manage/admin/operations'
import { Route as ManageManageAdminLogsRouteImport } from './routes/_manage/manage/admin/logs'
import { Route as ManageManageAdminDrawingsRouteImport } from './routes/_manage/manage/admin/drawings'
import { Route as ManageManageAdminDashboardRouteImport } from './routes/_manage/manage/admin/dashboard'
import { Route as ManageManageAdminWorkflowsIndexRouteImport } from './routes/_manage/manage/admin/workflows/index'
import { Route as ManageManageAdminUsersIndexRouteImport } from './routes/_manage/manage/admin/users/index'
import { Route as ManageManageAdminTasksIndexRouteImport } from './routes/_manage/manage/admin/tasks/index'
import { Route as ManageManageAdminProjectsIndexRouteImport } from './routes/_manage/manage/admin/projects/index'
import { Route as ManageManageAdminOrganizationsIndexRouteImport } from './routes/_manage/manage/admin/organizations/index'
import { Route as ManageManageAdminModelsIndexRouteImport } from './routes/_manage/manage/admin/models/index'
import { Route as ManageManageAdminJobsIndexRouteImport } from './routes/_manage/manage/admin/jobs/index'
import { Route as ManageManageAdminFilesIndexRouteImport } from './routes/_manage/manage/admin/files/index'
import { Route as ManageManageProjectsIdEditRouteImport } from './routes/_manage/manage/projects/$id_.edit'
import { Route as ManageManageOrganizationOperationTypesNewRouteImport } from './routes/_manage/manage/organization/operation-types_.new'
import { Route as ManageManageOrganizationOperationTypesTypeIdRouteImport } from './routes/_manage/manage/organization/operation-types_.$typeId'
import { Route as ManageManageOperationsOperationIdEditRouteImport } from './routes/_manage/manage/operations/$operationId.edit'
import { Route as ManageManageAdminWorkflowsIdRouteImport } from './routes/_manage/manage/admin/workflows/$id'
import { Route as ManageManageAdminUsersNewRouteImport } from './routes/_manage/manage/admin/users/new'
import { Route as ManageManageAdminUsersIdRouteImport } from './routes/_manage/manage/admin/users/$id'
import { Route as ManageManageAdminTasksIdRouteImport } from './routes/_manage/manage/admin/tasks/$id'
import { Route as ManageManageAdminOrganizationsIdRouteImport } from './routes/_manage/manage/admin/organizations/$id'
import { Route as ManageManageAdminModelsIdRouteImport } from './routes/_manage/manage/admin/models/$id'
import { Route as ManageManageAdminFilesShareIdRouteImport } from './routes/_manage/manage/admin/files/$shareId'
import { Route as ManageManageAdminOperationsTypesRouteImport } from './routes/_manage/manage/admin/operations/types'
import { Route as ManageManageAdminOperationsListRouteImport } from './routes/_manage/manage/admin/operations/list'
import { Route as ManageManageAdminDrawingsIndexRouteImport } from './routes/_manage/manage/admin/drawings/index'
import { Route as ManageManageAdminDrawingsIdRouteImport } from './routes/_manage/manage/admin/drawings/$id'
import { Route as ManageManageAdminDashboardIndexRouteImport } from './routes/_manage/manage/admin/dashboard/index'
import { Route as ManageManageAdminDashboardSettingsRouteImport } from './routes/_manage/manage/admin/dashboard/settings'
import { Route as ManageManageAdminDashboardEmailSettingsRouteImport } from './routes/_manage/manage/admin/dashboard/email-settings'
import { Route as ManageManageAdminDashboardCronJobsRouteImport } from './routes/_manage/manage/admin/dashboard/cron-jobs'
import { Route as ManageManageAdminDashboardAnnouncementsRouteImport } from './routes/_manage/manage/admin/dashboard/announcements'
import { Route as ManageManageOrganizationOperationsOperationIdEditRouteImport } from './routes/_manage/manage/organization/operations_.$operationId.edit'
import { Route as ManageManageOrganizationOperationTypesTypeIdEditRouteImport } from './routes/_manage/manage/organization/operation-types_.$typeId.edit'
import { Route as ManageManageAdminOperationsTypesNewRouteImport } from './routes/_manage/manage/admin/operations/types_.new'
import { Route as ManageManageAdminOperationsTypesTypeIdRouteImport } from './routes/_manage/manage/admin/operations/types_.$typeId'
import { Route as ManageManageDrawingsIdOperationsOperationTypeIdNewRouteImport } from './routes/_manage/manage/drawings_.$id.operations.$operationTypeId.new'
import { Route as ManageManageAdminOperationsTypesTypeIdEditRouteImport } from './routes/_manage/manage/admin/operations/types_.$typeId.edit'

const ShareTargetRoute = ShareTargetRouteImport.update({
            id: '/share-target',path: '/share-target',getParentRoute: () => rootRouteImport
          })
const NotPermittedRoute = NotPermittedRouteImport.update({
            id: '/not-permitted',path: '/not-permitted',getParentRoute: () => rootRouteImport
          })
const CreateRoute = CreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => rootRouteImport
          })
const ToolsRoute = ToolsRouteImport.update({
            id: '/_tools',getParentRoute: () => rootRouteImport
          })
const StaticRoute = StaticRouteImport.update({
            id: '/_static',getParentRoute: () => rootRouteImport
          })
const ManageRoute = ManageRouteImport.update({
            id: '/_manage',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UploadIndexRoute = UploadIndexRouteImport.update({
            id: '/upload/',path: '/upload/',getParentRoute: () => rootRouteImport
          })
const ResultsIndexRoute = ResultsIndexRouteImport.update({
            id: '/results/',path: '/results/',getParentRoute: () => rootRouteImport
          })
const SShareIdRoute = SShareIdRouteImport.update({
            id: '/s/$shareId',path: '/s/$shareId',getParentRoute: () => rootRouteImport
          })
const ProjectShareIdRoute = ProjectShareIdRouteImport.update({
            id: '/project/$shareId',path: '/project/$shareId',getParentRoute: () => rootRouteImport
          })
const FileShareIdRoute = FileShareIdRouteImport.update({
            id: '/file/$shareId',path: '/file/$shareId',getParentRoute: () => rootRouteImport
          })
const DrawingShareIdRoute = DrawingShareIdRouteImport.update({
            id: '/drawing/$shareId',path: '/drawing/$shareId',getParentRoute: () => rootRouteImport
          })
const ApiQrcodeRoute = ApiQrcodeRouteImport.update({
            id: '/api/qrcode',path: '/api/qrcode',getParentRoute: () => rootRouteImport
          })
const StaticTermsRoute = StaticTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => StaticRoute
          })
const StaticPrivacyRoute = StaticPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => StaticRoute
          })
const StaticPricingRoute = StaticPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => StaticRoute
          })
const StaticLegalRoute = StaticLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => StaticRoute
          })
const StaticInboundEmailLimitsRoute = StaticInboundEmailLimitsRouteImport.update({
            id: '/inbound-email-limits',path: '/inbound-email-limits',getParentRoute: () => StaticRoute
          })
const StaticFaqRoute = StaticFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => StaticRoute
          })
const StaticDocsRoute = StaticDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => StaticRoute
          })
const StaticContactRoute = StaticContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => StaticRoute
          })
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthRegisterRoute = AuthRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => AuthRoute
          })
const AuthLogoutRoute = AuthLogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => AuthRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const ToolsToolsIndexRoute = ToolsToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => ToolsRoute
          })
const StaticDocsIndexRoute = StaticDocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StaticDocsRoute
          })
const StaticDocsWorkflowsRoute = StaticDocsWorkflowsRouteImport.update({
            id: '/workflows',path: '/workflows',getParentRoute: () => StaticDocsRoute
          })
const StaticDocsTemplatesRoute = StaticDocsTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => StaticDocsRoute
          })
const StaticDocsStorageRoute = StaticDocsStorageRouteImport.update({
            id: '/storage',path: '/storage',getParentRoute: () => StaticDocsRoute
          })
const StaticDocsQuickstartRoute = StaticDocsQuickstartRouteImport.update({
            id: '/quickstart',path: '/quickstart',getParentRoute: () => StaticDocsRoute
          })
const StaticDocsEmailInboundRoute = StaticDocsEmailInboundRouteImport.update({
            id: '/email-inbound',path: '/email-inbound',getParentRoute: () => StaticDocsRoute
          })
const StaticDocsApiRoute = StaticDocsApiRouteImport.update({
            id: '/api',path: '/api',getParentRoute: () => StaticDocsRoute
          })
const ManageManageIndexRoute = ManageManageIndexRouteImport.update({
            id: '/manage/',path: '/manage/',getParentRoute: () => ManageRoute
          })
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthLoginRoute
          })
const AuthLoginEmailRoute = AuthLoginEmailRouteImport.update({
            id: '/email',path: '/email',getParentRoute: () => AuthLoginRoute
          })
const ToolsToolsMaterialsIndexRoute = ToolsToolsMaterialsIndexRouteImport.update({
            id: '/tools/materials/',path: '/tools/materials/',getParentRoute: () => ToolsRoute
          })
const ManageManageWorkflowsIndexRoute = ManageManageWorkflowsIndexRouteImport.update({
            id: '/manage/workflows/',path: '/manage/workflows/',getParentRoute: () => ManageRoute
          })
const ManageManageUsageIndexRoute = ManageManageUsageIndexRouteImport.update({
            id: '/manage/usage/',path: '/manage/usage/',getParentRoute: () => ManageRoute
          })
const ManageManageTemplatesIndexRoute = ManageManageTemplatesIndexRouteImport.update({
            id: '/manage/templates/',path: '/manage/templates/',getParentRoute: () => ManageRoute
          })
const ManageManageProjectsIndexRoute = ManageManageProjectsIndexRouteImport.update({
            id: '/manage/projects/',path: '/manage/projects/',getParentRoute: () => ManageRoute
          })
const ManageManageOrganizeIndexRoute = ManageManageOrganizeIndexRouteImport.update({
            id: '/manage/organize/',path: '/manage/organize/',getParentRoute: () => ManageRoute
          })
const ManageManageOrganizationIndexRoute = ManageManageOrganizationIndexRouteImport.update({
            id: '/manage/organization/',path: '/manage/organization/',getParentRoute: () => ManageRoute
          })
const ManageManageOperationsIndexRoute = ManageManageOperationsIndexRouteImport.update({
            id: '/manage/operations/',path: '/manage/operations/',getParentRoute: () => ManageRoute
          })
const ManageManageMergeIndexRoute = ManageManageMergeIndexRouteImport.update({
            id: '/manage/merge/',path: '/manage/merge/',getParentRoute: () => ManageRoute
          })
const ManageManageFilesIndexRoute = ManageManageFilesIndexRouteImport.update({
            id: '/manage/files/',path: '/manage/files/',getParentRoute: () => ManageRoute
          })
const ManageManageDrawingsIndexRoute = ManageManageDrawingsIndexRouteImport.update({
            id: '/manage/drawings/',path: '/manage/drawings/',getParentRoute: () => ManageRoute
          })
const ManageManageDashboardIndexRoute = ManageManageDashboardIndexRouteImport.update({
            id: '/manage/dashboard/',path: '/manage/dashboard/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminIndexRoute = ManageManageAdminIndexRouteImport.update({
            id: '/manage/admin/',path: '/manage/admin/',getParentRoute: () => ManageRoute
          })
const ManageManageAccountIndexRoute = ManageManageAccountIndexRouteImport.update({
            id: '/manage/account/',path: '/manage/account/',getParentRoute: () => ManageRoute
          })
const ManageManageWorkflowsIdRoute = ManageManageWorkflowsIdRouteImport.update({
            id: '/manage/workflows/$id',path: '/manage/workflows/$id',getParentRoute: () => ManageRoute
          })
const ManageManageTemplatesIdRoute = ManageManageTemplatesIdRouteImport.update({
            id: '/manage/templates/$id',path: '/manage/templates/$id',getParentRoute: () => ManageRoute
          })
const ManageManageProjectsNewRoute = ManageManageProjectsNewRouteImport.update({
            id: '/manage/projects/new',path: '/manage/projects/new',getParentRoute: () => ManageRoute
          })
const ManageManageProjectsIdRoute = ManageManageProjectsIdRouteImport.update({
            id: '/manage/projects/$id',path: '/manage/projects/$id',getParentRoute: () => ManageRoute
          })
const ManageManageOrganizationSettingsRoute = ManageManageOrganizationSettingsRouteImport.update({
            id: '/manage/organization/settings',path: '/manage/organization/settings',getParentRoute: () => ManageRoute
          })
const ManageManageOrganizationOperationTypesRoute = ManageManageOrganizationOperationTypesRouteImport.update({
            id: '/manage/organization/operation-types',path: '/manage/organization/operation-types',getParentRoute: () => ManageRoute
          })
const ManageManageFilesShareIdRoute = ManageManageFilesShareIdRouteImport.update({
            id: '/manage/files/$shareId',path: '/manage/files/$shareId',getParentRoute: () => ManageRoute
          })
const ManageManageDrawingsSearchRoute = ManageManageDrawingsSearchRouteImport.update({
            id: '/manage/drawings/search',path: '/manage/drawings/search',getParentRoute: () => ManageRoute
          })
const ManageManageDrawingsRapidRoute = ManageManageDrawingsRapidRouteImport.update({
            id: '/manage/drawings/rapid',path: '/manage/drawings/rapid',getParentRoute: () => ManageRoute
          })
const ManageManageDrawingsNewRoute = ManageManageDrawingsNewRouteImport.update({
            id: '/manage/drawings/new',path: '/manage/drawings/new',getParentRoute: () => ManageRoute
          })
const ManageManageDrawingsIdRoute = ManageManageDrawingsIdRouteImport.update({
            id: '/manage/drawings/$id',path: '/manage/drawings/$id',getParentRoute: () => ManageRoute
          })
const ManageManageAdminTemplatesRoute = ManageManageAdminTemplatesRouteImport.update({
            id: '/manage/admin/templates',path: '/manage/admin/templates',getParentRoute: () => ManageRoute
          })
const ManageManageAdminSettingsRoute = ManageManageAdminSettingsRouteImport.update({
            id: '/manage/admin/settings',path: '/manage/admin/settings',getParentRoute: () => ManageRoute
          })
const ManageManageAdminRateLimitsRoute = ManageManageAdminRateLimitsRouteImport.update({
            id: '/manage/admin/rate-limits',path: '/manage/admin/rate-limits',getParentRoute: () => ManageRoute
          })
const ManageManageAdminOperationsRoute = ManageManageAdminOperationsRouteImport.update({
            id: '/manage/admin/operations',path: '/manage/admin/operations',getParentRoute: () => ManageRoute
          })
const ManageManageAdminLogsRoute = ManageManageAdminLogsRouteImport.update({
            id: '/manage/admin/logs',path: '/manage/admin/logs',getParentRoute: () => ManageRoute
          })
const ManageManageAdminDrawingsRoute = ManageManageAdminDrawingsRouteImport.update({
            id: '/manage/admin/drawings',path: '/manage/admin/drawings',getParentRoute: () => ManageRoute
          })
const ManageManageAdminDashboardRoute = ManageManageAdminDashboardRouteImport.update({
            id: '/manage/admin/dashboard',path: '/manage/admin/dashboard',getParentRoute: () => ManageRoute
          })
const ManageManageAdminWorkflowsIndexRoute = ManageManageAdminWorkflowsIndexRouteImport.update({
            id: '/manage/admin/workflows/',path: '/manage/admin/workflows/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminUsersIndexRoute = ManageManageAdminUsersIndexRouteImport.update({
            id: '/manage/admin/users/',path: '/manage/admin/users/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminTasksIndexRoute = ManageManageAdminTasksIndexRouteImport.update({
            id: '/manage/admin/tasks/',path: '/manage/admin/tasks/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminProjectsIndexRoute = ManageManageAdminProjectsIndexRouteImport.update({
            id: '/manage/admin/projects/',path: '/manage/admin/projects/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminOrganizationsIndexRoute = ManageManageAdminOrganizationsIndexRouteImport.update({
            id: '/manage/admin/organizations/',path: '/manage/admin/organizations/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminModelsIndexRoute = ManageManageAdminModelsIndexRouteImport.update({
            id: '/manage/admin/models/',path: '/manage/admin/models/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminJobsIndexRoute = ManageManageAdminJobsIndexRouteImport.update({
            id: '/manage/admin/jobs/',path: '/manage/admin/jobs/',getParentRoute: () => ManageRoute
          })
const ManageManageAdminFilesIndexRoute = ManageManageAdminFilesIndexRouteImport.update({
            id: '/manage/admin/files/',path: '/manage/admin/files/',getParentRoute: () => ManageRoute
          })
const ManageManageProjectsIdEditRoute = ManageManageProjectsIdEditRouteImport.update({
            id: '/manage/projects/$id_/edit',path: '/manage/projects/$id/edit',getParentRoute: () => ManageRoute
          })
const ManageManageOrganizationOperationTypesNewRoute = ManageManageOrganizationOperationTypesNewRouteImport.update({
            id: '/manage/organization/operation-types_/new',path: '/manage/organization/operation-types/new',getParentRoute: () => ManageRoute
          })
const ManageManageOrganizationOperationTypesTypeIdRoute = ManageManageOrganizationOperationTypesTypeIdRouteImport.update({
            id: '/manage/organization/operation-types_/$typeId',path: '/manage/organization/operation-types/$typeId',getParentRoute: () => ManageRoute
          })
const ManageManageOperationsOperationIdEditRoute = ManageManageOperationsOperationIdEditRouteImport.update({
            id: '/manage/operations/$operationId/edit',path: '/manage/operations/$operationId/edit',getParentRoute: () => ManageRoute
          })
const ManageManageAdminWorkflowsIdRoute = ManageManageAdminWorkflowsIdRouteImport.update({
            id: '/manage/admin/workflows/$id',path: '/manage/admin/workflows/$id',getParentRoute: () => ManageRoute
          })
const ManageManageAdminUsersNewRoute = ManageManageAdminUsersNewRouteImport.update({
            id: '/manage/admin/users/new',path: '/manage/admin/users/new',getParentRoute: () => ManageRoute
          })
const ManageManageAdminUsersIdRoute = ManageManageAdminUsersIdRouteImport.update({
            id: '/manage/admin/users/$id',path: '/manage/admin/users/$id',getParentRoute: () => ManageRoute
          })
const ManageManageAdminTasksIdRoute = ManageManageAdminTasksIdRouteImport.update({
            id: '/manage/admin/tasks/$id',path: '/manage/admin/tasks/$id',getParentRoute: () => ManageRoute
          })
const ManageManageAdminOrganizationsIdRoute = ManageManageAdminOrganizationsIdRouteImport.update({
            id: '/manage/admin/organizations/$id',path: '/manage/admin/organizations/$id',getParentRoute: () => ManageRoute
          })
const ManageManageAdminModelsIdRoute = ManageManageAdminModelsIdRouteImport.update({
            id: '/manage/admin/models/$id',path: '/manage/admin/models/$id',getParentRoute: () => ManageRoute
          })
const ManageManageAdminFilesShareIdRoute = ManageManageAdminFilesShareIdRouteImport.update({
            id: '/manage/admin/files/$shareId',path: '/manage/admin/files/$shareId',getParentRoute: () => ManageRoute
          })
const ManageManageAdminOperationsTypesRoute = ManageManageAdminOperationsTypesRouteImport.update({
            id: '/types',path: '/types',getParentRoute: () => ManageManageAdminOperationsRoute
          })
const ManageManageAdminOperationsListRoute = ManageManageAdminOperationsListRouteImport.update({
            id: '/list',path: '/list',getParentRoute: () => ManageManageAdminOperationsRoute
          })
const ManageManageAdminDrawingsIndexRoute = ManageManageAdminDrawingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ManageManageAdminDrawingsRoute
          })
const ManageManageAdminDrawingsIdRoute = ManageManageAdminDrawingsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => ManageManageAdminDrawingsRoute
          })
const ManageManageAdminDashboardIndexRoute = ManageManageAdminDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ManageManageAdminDashboardRoute
          })
const ManageManageAdminDashboardSettingsRoute = ManageManageAdminDashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ManageManageAdminDashboardRoute
          })
const ManageManageAdminDashboardEmailSettingsRoute = ManageManageAdminDashboardEmailSettingsRouteImport.update({
            id: '/email-settings',path: '/email-settings',getParentRoute: () => ManageManageAdminDashboardRoute
          })
const ManageManageAdminDashboardCronJobsRoute = ManageManageAdminDashboardCronJobsRouteImport.update({
            id: '/cron-jobs',path: '/cron-jobs',getParentRoute: () => ManageManageAdminDashboardRoute
          })
const ManageManageAdminDashboardAnnouncementsRoute = ManageManageAdminDashboardAnnouncementsRouteImport.update({
            id: '/announcements',path: '/announcements',getParentRoute: () => ManageManageAdminDashboardRoute
          })
const ManageManageOrganizationOperationsOperationIdEditRoute = ManageManageOrganizationOperationsOperationIdEditRouteImport.update({
            id: '/manage/organization/operations_/$operationId/edit',path: '/manage/organization/operations/$operationId/edit',getParentRoute: () => ManageRoute
          })
const ManageManageOrganizationOperationTypesTypeIdEditRoute = ManageManageOrganizationOperationTypesTypeIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => ManageManageOrganizationOperationTypesTypeIdRoute
          })
const ManageManageAdminOperationsTypesNewRoute = ManageManageAdminOperationsTypesNewRouteImport.update({
            id: '/types_/new',path: '/types/new',getParentRoute: () => ManageManageAdminOperationsRoute
          })
const ManageManageAdminOperationsTypesTypeIdRoute = ManageManageAdminOperationsTypesTypeIdRouteImport.update({
            id: '/types_/$typeId',path: '/types/$typeId',getParentRoute: () => ManageManageAdminOperationsRoute
          })
const ManageManageDrawingsIdOperationsOperationTypeIdNewRoute = ManageManageDrawingsIdOperationsOperationTypeIdNewRouteImport.update({
            id: '/manage/drawings_/$id/operations/$operationTypeId/new',path: '/manage/drawings/$id/operations/$operationTypeId/new',getParentRoute: () => ManageRoute
          })
const ManageManageAdminOperationsTypesTypeIdEditRoute = ManageManageAdminOperationsTypesTypeIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => ManageManageAdminOperationsTypesTypeIdRoute
          })





const AuthLoginRouteChildren = {
  AuthLoginEmailRoute: AuthLoginEmailRoute,AuthLoginIndexRoute: AuthLoginIndexRoute
}

const AuthLoginRouteWithChildren = AuthLoginRoute._addFileChildren(AuthLoginRouteChildren)



const AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRouteWithChildren,AuthLogoutRoute: AuthLogoutRoute,AuthRegisterRoute: AuthRegisterRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthVerifyEmailRoute: AuthVerifyEmailRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const ManageManageAdminDashboardRouteChildren = {
  ManageManageAdminDashboardAnnouncementsRoute: ManageManageAdminDashboardAnnouncementsRoute,ManageManageAdminDashboardCronJobsRoute: ManageManageAdminDashboardCronJobsRoute,ManageManageAdminDashboardEmailSettingsRoute: ManageManageAdminDashboardEmailSettingsRoute,ManageManageAdminDashboardSettingsRoute: ManageManageAdminDashboardSettingsRoute,ManageManageAdminDashboardIndexRoute: ManageManageAdminDashboardIndexRoute
}

const ManageManageAdminDashboardRouteWithChildren = ManageManageAdminDashboardRoute._addFileChildren(ManageManageAdminDashboardRouteChildren)




const ManageManageAdminDrawingsRouteChildren = {
  ManageManageAdminDrawingsIdRoute: ManageManageAdminDrawingsIdRoute,ManageManageAdminDrawingsIndexRoute: ManageManageAdminDrawingsIndexRoute
}

const ManageManageAdminDrawingsRouteWithChildren = ManageManageAdminDrawingsRoute._addFileChildren(ManageManageAdminDrawingsRouteChildren)




const ManageManageAdminOperationsTypesTypeIdRouteChildren = {
  ManageManageAdminOperationsTypesTypeIdEditRoute: ManageManageAdminOperationsTypesTypeIdEditRoute
}

const ManageManageAdminOperationsTypesTypeIdRouteWithChildren = ManageManageAdminOperationsTypesTypeIdRoute._addFileChildren(ManageManageAdminOperationsTypesTypeIdRouteChildren)



const ManageManageAdminOperationsRouteChildren = {
  ManageManageAdminOperationsListRoute: ManageManageAdminOperationsListRoute,ManageManageAdminOperationsTypesRoute: ManageManageAdminOperationsTypesRoute,ManageManageAdminOperationsTypesTypeIdRoute: ManageManageAdminOperationsTypesTypeIdRouteWithChildren,ManageManageAdminOperationsTypesNewRoute: ManageManageAdminOperationsTypesNewRoute
}

const ManageManageAdminOperationsRouteWithChildren = ManageManageAdminOperationsRoute._addFileChildren(ManageManageAdminOperationsRouteChildren)




const ManageManageOrganizationOperationTypesTypeIdRouteChildren = {
  ManageManageOrganizationOperationTypesTypeIdEditRoute: ManageManageOrganizationOperationTypesTypeIdEditRoute
}

const ManageManageOrganizationOperationTypesTypeIdRouteWithChildren = ManageManageOrganizationOperationTypesTypeIdRoute._addFileChildren(ManageManageOrganizationOperationTypesTypeIdRouteChildren)



const ManageRouteChildren = {
  ManageManageIndexRoute: ManageManageIndexRoute,ManageManageAdminDashboardRoute: ManageManageAdminDashboardRouteWithChildren,ManageManageAdminDrawingsRoute: ManageManageAdminDrawingsRouteWithChildren,ManageManageAdminLogsRoute: ManageManageAdminLogsRoute,ManageManageAdminOperationsRoute: ManageManageAdminOperationsRouteWithChildren,ManageManageAdminRateLimitsRoute: ManageManageAdminRateLimitsRoute,ManageManageAdminSettingsRoute: ManageManageAdminSettingsRoute,ManageManageAdminTemplatesRoute: ManageManageAdminTemplatesRoute,ManageManageDrawingsIdRoute: ManageManageDrawingsIdRoute,ManageManageDrawingsNewRoute: ManageManageDrawingsNewRoute,ManageManageDrawingsRapidRoute: ManageManageDrawingsRapidRoute,ManageManageDrawingsSearchRoute: ManageManageDrawingsSearchRoute,ManageManageFilesShareIdRoute: ManageManageFilesShareIdRoute,ManageManageOrganizationOperationTypesRoute: ManageManageOrganizationOperationTypesRoute,ManageManageOrganizationSettingsRoute: ManageManageOrganizationSettingsRoute,ManageManageProjectsIdRoute: ManageManageProjectsIdRoute,ManageManageProjectsNewRoute: ManageManageProjectsNewRoute,ManageManageTemplatesIdRoute: ManageManageTemplatesIdRoute,ManageManageWorkflowsIdRoute: ManageManageWorkflowsIdRoute,ManageManageAccountIndexRoute: ManageManageAccountIndexRoute,ManageManageAdminIndexRoute: ManageManageAdminIndexRoute,ManageManageDashboardIndexRoute: ManageManageDashboardIndexRoute,ManageManageDrawingsIndexRoute: ManageManageDrawingsIndexRoute,ManageManageFilesIndexRoute: ManageManageFilesIndexRoute,ManageManageMergeIndexRoute: ManageManageMergeIndexRoute,ManageManageOperationsIndexRoute: ManageManageOperationsIndexRoute,ManageManageOrganizationIndexRoute: ManageManageOrganizationIndexRoute,ManageManageOrganizeIndexRoute: ManageManageOrganizeIndexRoute,ManageManageProjectsIndexRoute: ManageManageProjectsIndexRoute,ManageManageTemplatesIndexRoute: ManageManageTemplatesIndexRoute,ManageManageUsageIndexRoute: ManageManageUsageIndexRoute,ManageManageWorkflowsIndexRoute: ManageManageWorkflowsIndexRoute,ManageManageAdminFilesShareIdRoute: ManageManageAdminFilesShareIdRoute,ManageManageAdminModelsIdRoute: ManageManageAdminModelsIdRoute,ManageManageAdminOrganizationsIdRoute: ManageManageAdminOrganizationsIdRoute,ManageManageAdminTasksIdRoute: ManageManageAdminTasksIdRoute,ManageManageAdminUsersIdRoute: ManageManageAdminUsersIdRoute,ManageManageAdminUsersNewRoute: ManageManageAdminUsersNewRoute,ManageManageAdminWorkflowsIdRoute: ManageManageAdminWorkflowsIdRoute,ManageManageOperationsOperationIdEditRoute: ManageManageOperationsOperationIdEditRoute,ManageManageOrganizationOperationTypesTypeIdRoute: ManageManageOrganizationOperationTypesTypeIdRouteWithChildren,ManageManageOrganizationOperationTypesNewRoute: ManageManageOrganizationOperationTypesNewRoute,ManageManageProjectsIdEditRoute: ManageManageProjectsIdEditRoute,ManageManageAdminFilesIndexRoute: ManageManageAdminFilesIndexRoute,ManageManageAdminJobsIndexRoute: ManageManageAdminJobsIndexRoute,ManageManageAdminModelsIndexRoute: ManageManageAdminModelsIndexRoute,ManageManageAdminOrganizationsIndexRoute: ManageManageAdminOrganizationsIndexRoute,ManageManageAdminProjectsIndexRoute: ManageManageAdminProjectsIndexRoute,ManageManageAdminTasksIndexRoute: ManageManageAdminTasksIndexRoute,ManageManageAdminUsersIndexRoute: ManageManageAdminUsersIndexRoute,ManageManageAdminWorkflowsIndexRoute: ManageManageAdminWorkflowsIndexRoute,ManageManageOrganizationOperationsOperationIdEditRoute: ManageManageOrganizationOperationsOperationIdEditRoute,ManageManageDrawingsIdOperationsOperationTypeIdNewRoute: ManageManageDrawingsIdOperationsOperationTypeIdNewRoute
}

const ManageRouteWithChildren = ManageRoute._addFileChildren(ManageRouteChildren)




const StaticDocsRouteChildren = {
  StaticDocsApiRoute: StaticDocsApiRoute,StaticDocsEmailInboundRoute: StaticDocsEmailInboundRoute,StaticDocsQuickstartRoute: StaticDocsQuickstartRoute,StaticDocsStorageRoute: StaticDocsStorageRoute,StaticDocsTemplatesRoute: StaticDocsTemplatesRoute,StaticDocsWorkflowsRoute: StaticDocsWorkflowsRoute,StaticDocsIndexRoute: StaticDocsIndexRoute
}

const StaticDocsRouteWithChildren = StaticDocsRoute._addFileChildren(StaticDocsRouteChildren)



const StaticRouteChildren = {
  StaticContactRoute: StaticContactRoute,StaticDocsRoute: StaticDocsRouteWithChildren,StaticFaqRoute: StaticFaqRoute,StaticInboundEmailLimitsRoute: StaticInboundEmailLimitsRoute,StaticLegalRoute: StaticLegalRoute,StaticPricingRoute: StaticPricingRoute,StaticPrivacyRoute: StaticPrivacyRoute,StaticTermsRoute: StaticTermsRoute
}

const StaticRouteWithChildren = StaticRoute._addFileChildren(StaticRouteChildren)




const ToolsRouteChildren = {
  ToolsToolsIndexRoute: ToolsToolsIndexRoute,ToolsToolsMaterialsIndexRoute: ToolsToolsMaterialsIndexRoute
}

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRouteWithChildren,ManageRoute: ManageRouteWithChildren,StaticRoute: StaticRouteWithChildren,ToolsRoute: ToolsRouteWithChildren,CreateRoute: CreateRoute,NotPermittedRoute: NotPermittedRoute,ShareTargetRoute: ShareTargetRoute,ApiQrcodeRoute: ApiQrcodeRoute,DrawingShareIdRoute: DrawingShareIdRoute,FileShareIdRoute: FileShareIdRoute,ProjectShareIdRoute: ProjectShareIdRoute,SShareIdRoute: SShareIdRoute,ResultsIndexRoute: ResultsIndexRoute,UploadIndexRoute: UploadIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)